export default {"src":"/_next/static/media/arrow_right_gold_2.31a083cc.svg","height":47,"width":48,"blurWidth":0,"blurHeight":0};